import '../scss/app.scss';
import 'bootstrap';
import 'flickity';
import 'flickity-as-nav-for';
import './jquery-plugins/jquery.bootstrap-dropdown-hover.js';
import './jquery-plugins/jquery.menu-aim.js';

import './util/polyfills';

// use unobtrusive validation. additional validation can be added.
//import _ from "jquery-validation-unobtrusive";

import './product';
import './MenuNodes';
import { showMiniCart, hideMiniCart, refreshMiniCart, displayAddToCartConfirmation, saveAddToCartConfirmation, displayAddToCartLoginModal } from './cart';
import Skin from './skin';
import './Carousels/carouselFeaturedProducts.js';
import catalogEntryGallery from './Carousels/catalogEntryGallery';
import tileCarousels from './Carousels/tileCarousels';
import addonCarousel from './Carousels/addonCarousel';
import './Forms';
import './NeoCenter/neocenterLandingPage.js';
import './MapBlock/mapBlock.js';
import initAddToCalendarModal from './Modals/addToCalendarModal';
import './Modals/slideModal';
import './helpers/truncate';
import * as gtm from './gtm';
import { tryToggleTab } from './helpers/toggletab';
import { translateResourceString, addResourceStrings, assignEVTDataIntoForm } from './util';
import displayLoginModal from './Modals/loginModal';
import initDateHelper from './helpers/dateHelper';

import './internationalization/market.js';
import './internationalization/countrypicker.js';

$(document).ready(() => {
    Skin.init();
    Skin.initHash();
    catalogEntryGallery();
    tileCarousels();
    addonCarousel();
    initAddToCalendarModal();
    initDateHelper();
}
);

global["MiniCart"] = global["MiniCart"] || {}
global["AddToCartConfirmation"] = global["AddToCartConfirmation"] || {}
global["AddToCartLoginModal"] = global["AddToCartLoginModal"] || {};
global["LoginModal"] = global["LoginModal"] || {}
global.MiniCart.show = showMiniCart;
global.MiniCart.hide = hideMiniCart;
global.MiniCart.refresh = refreshMiniCart;
global.gtm = gtm;
global.tryToggleTab = tryToggleTab;
global.AddToCartConfirmation.displayAddToCartConfirmation = displayAddToCartConfirmation;
global.AddToCartConfirmation.saveAddToCartConfirmation = saveAddToCartConfirmation;
global.LoginModal.displayLoginModal = displayLoginModal;
global.AddToCartLoginModal.displayAddToCartLoginModal = displayAddToCartLoginModal;

global.TranslationUtility = global["TranslationUtility"] || {};
global.TranslationUtility.translateResourceString = translateResourceString;
global.TranslationUtility.addResourceStrings = addResourceStrings;
global.assignEVTDataIntoForm = assignEVTDataIntoForm;

global.jQuery = $;
window.jQuery = $;
window.$ = $;

import { formDataToBody, makeFormData } from '../../../CRA/src/Components/util/catalystFormDataBuilder';
import { makeCatalystFetchPostInit } from '../../../CRA/src/Components/util/fetchUtility';
global.FormDataUtil = {
    makeFormData,
    formDataToBody,
    makeCatalystFetchPostInit
};

// Create a custom event for combining various window.location changing events.
(() => {
    let oldPushState = history.pushState;
    history.pushState = function pushState() {
        let ret = oldPushState.apply(this, arguments);
        window.dispatchEvent(new Event('pushstate'));
        window.dispatchEvent(new Event('locationchange'));
        return ret;
    };

    let oldReplaceState = history.replaceState;
    history.replaceState = function replaceState() {
        let ret = oldReplaceState.apply(this, arguments);
        window.dispatchEvent(new Event('replacestate'));
        window.dispatchEvent(new Event('locationchange'));
        return ret;
    };

    window.addEventListener('popstate', () => {
        window.dispatchEvent(new Event('locationchange'));
    });
})();